import { Ebooks_Details, Ebooks_Listing } from '../QueryKeys/ebook.key';
import { useInfiniteQuery, useQuery, useQueryClient, useMutation } from 'react-query';
import axiosInstance from '../../Store/helper/axiosInstance';
import { generateUtmExt, getLocalStorage, isMobileApp, setLocalStorage } from '../../common/common';
import { GET_VAULT_LIST } from '../QueryKeys/vault.key';
import { renderHeaderOnce } from '../../Store/actions';
import { useDispatch } from 'react-redux';
import useFeedInitialData from '../utils/useFeedInitialData';

const staleTime = 300000;
const cacheTime = 600000;

const fetchData = ({ queryKey }) => {
  const id = queryKey[1];

  return axiosInstance.get(`epub/detail?type_id=${id}${generateUtmExt()}`);
};
export const useEbookDetails = (id, onSuccess, enabled) => {
  const queryClient = useQueryClient();
  return useQuery([Ebooks_Details, id], fetchData, {
    enabled,
    onSuccess,
    refetchOnWindowFocus: false,
    select: (res) => res.data.data,
    initialData: () => {
      const ebookDetailsFeatured = queryClient
        .getQueryData(Ebooks_Listing)
        ?.pages?.map((page) => page?.data?.data)
        ?.flat()
        ?.find((e) => e.type_id == id);
      const ebookDetailsVault = queryClient
        .getQueryData(GET_VAULT_LIST)
        ?.data?.data?.find((e) => e.type_id == id);
      const [ebookChannel, ebookUiV3Dashboard] = useFeedInitialData('epub', id);

      const ebookDetails =
        ebookDetailsFeatured || ebookDetailsVault || ebookChannel || ebookUiV3Dashboard;
      console.log('ebook details', ebookDetails);

      if (ebookDetails) {
        return { data: { data: ebookDetails } };
      } else {
        return undefined;
      }
    }
  });
};

export const useEbookList = () => {
  return useInfiniteQuery(
    Ebooks_Listing,
    ({ pageParam = 0 }) =>
      axiosInstance.get(`epub/listing?from=${pageParam}&to=10${isMobileApp() ? '&convert=1' : ''}`),
    {
      staleTime: staleTime,
      cacheTime: cacheTime,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage?.data?.data?.length == 10) {
          return allPages.length * 10;
        } else {
          return undefined;
        }
      }
      // onSuccess,
      // select: res => res.data.data
    }
  );
};

const saveLike = (data) => {
  return axiosInstance.post('knwlg/save_like', data);
};

export const useAddLike = (type, type_id) => {
  const queryClient = useQueryClient();

  return useMutation(saveLike, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION SAVELIKE', obj);
      const queryKeysArr = type == 'epub' ? [Ebooks_Details, type_id] : [Ebooks_Listing, type_id];
      console.log('querykeys', queryKeysArr);
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);
      console.log('Privious data', previousData);
      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        console.log('PREVIOUS', oldQueryData);
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              rating: oldQueryData.data.data.myrating
                ? oldQueryData.data.data.rating - 1
                : oldQueryData.data.data.rating + 1,
              myrating: !oldQueryData.data.data.myrating
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([Ebooks_Details, type_id]);
    }
  });
};

const saveVault = (data) => {
  return axiosInstance.post('knwlg/vault_switching', data);
};

export const useAddVault = (type, type_id) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  return useMutation(saveVault, {
    onMutate: async (obj) => {
      console.log('RQ MUTATION ADDVAULT', obj);
      const queryKeysArr = [Ebooks_Details, type_id];
      // await queryClient.cancelQueries([CL_VIDEO_DETAILS, type_id]);
      const previousData = queryClient.getQueryData(queryKeysArr);

      queryClient.setQueryData(queryKeysArr, (oldQueryData) => {
        // console.log('PREVIOUS', oldQueryData);
        return {
          ...oldQueryData,
          data: {
            ...oldQueryData.data,
            data: {
              ...oldQueryData.data.data,
              vault: oldQueryData.data.data.vault == 0 ? 1 : 0
            }
          }
        };
      });
      return { previousData };
    },
    onError: (_err, _obj, context) => {
      // queryClient.setQueryData([CL_VIDEO_DETAILS, type_id], context.previousData);
    },
    onSettled: () => {
      queryClient.invalidateQueries([Ebooks_Details, type_id]);
    },
    onSuccess: (resp) => {
      const res = resp.data;
      let vaultCount = getLocalStorage('vaultCount', false)
        ? parseInt(getLocalStorage('vaultCount', 0))
        : 0;
      // console.log('VAULT', vaultCount);
      if (res.data == 0) {
        setLocalStorage('vaultCount', vaultCount - 1);
      } else {
        setLocalStorage('vaultCount', vaultCount + 1);
      }
      dispatch(renderHeaderOnce());
    }
  });
};
